import React from "react";
import dots from "images/curved_pattern_dots.svg";
import lines from "images/green_dot_squiggle_lines.webp";

const DotsAndLines = ({ children }) => (
  <div className="relative">
    <div
      style={{
        background: `url(${dots})`,
        width: "392px",
        height: "367px",
        position: "absolute",
        top: "-91px",
        left: "-43px",
      }}
    />
    <div
      style={{
        background: `url(${lines})`,
        width: "325px",
        height: "307px",
        position: "absolute",
        bottom: "-114px",
        right: "-70px",
      }}
    />
    <div className="z-10 relative">{children}</div>
  </div>
);

export default DotsAndLines;
